import Vue from 'vue'
import Vuex from 'vuex'
// import axios from 'axios' // remove comment if yu needed
import Crud from '../crud'
const model = (payload) => ({
  // columns
  id: payload.id,
  name: payload.name,
  sku: payload.sku,
  category: payload.category,
  unit_price: payload.unit_price
})
var crud = new Crud('Products', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  products: []
}

const mutations = {
  ...crud.mutations
}

const actions = {
  ...crud.actions
}

const getters = {
  ...crud.getters,
  products: state => state.products
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
